//Imports

import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {useNavigate} from "react-router-dom";

//Functions & Declarations

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

//Function Starts

export default function Chooseperson() {

    let navigate = useNavigate();

    //Navigator for every Person

    const tim = () => {
        
    }


    const omi = () => {
        navigate("/intern/people/omi")
    }

    const klosters = () => {
        navigate("/intern/people/klosters")
    }


    //Styling
    const theme = useTheme();
    const [personName, setPersonName] = React.useState([]);

    //Dropdown Menu
    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setPersonName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };
//Returns dropdown Menu with Menu Items
    return (
        <div>
            <FormControl sx={{ m: 1, width: 350,  display: "flex", flexDirection: "column", '& .MuiTextField-root': { width: '30ch'},
                position: 'absolute', left: '50%', top: '50%',
                transform: 'translate(-50%, -50%)', borderRadius: 8, opacity: "100%" }}>
                <InputLabel id="demo-multiple-name-label">Auswahl</InputLabel>
                <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    multiple
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput label="Name" />}
                    MenuProps={MenuProps}
                >
                    <MenuItem disabled>
                        Sina
                    </MenuItem>
                    <MenuItem disabled>
                        Michael
                    </MenuItem>
                   <MenuItem disabled>
                        Tim
                   </MenuItem>
                    <MenuItem disabled>
                        Tobi
                    </MenuItem>
                    <MenuItem disabled>
                        Toni
                    </MenuItem>
                    <MenuItem
                   onClick={omi}>
                       Omi
                   </MenuItem>
                   <MenuItem onClick={klosters}>
                       Klosters
                   </MenuItem>
                </Select>
            </FormControl>
        </div>
    );
}
